"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const ModuleRegistryFactory_1 = tslib_1.__importDefault(require("../module/ModuleRegistryFactory"));
const SharedSecret_1 = tslib_1.__importDefault(require("./SharedSecret"));
class SharedSecretHandler {
    send(request, next, _) {
        const userContext = ModuleRegistryFactory_1.default.getModuleContext()?.getUserContext();
        // Note: Order must match order in project websecurity / SharedSecretFilter.checkSharedSecret():
        const loginId = userContext
            && (userContext.getProfessionalUuid() || userContext.getPersonUuid() || userContext.getRid() || userContext.getPid());
        const secret = SharedSecret_1.default.getSharedSecretValue(request.url, loginId, false);
        if (secret) {
            const sharedSecretName = SharedSecret_1.default.getSharedSecretName();
            request.headers[sharedSecretName] = secret;
        }
        next.send(request);
    }
    responseReceived(request, _, prev) {
        prev.responseReceived(request);
    }
}
exports.default = SharedSecretHandler;
//# sourceMappingURL=SharedSecretHandler.js.map